export const DELETE_EMPLOYER_MODAL_TITLE = "Delete customer"
export const DELETE_EMPLOYER_MODAL_TEXT = "Are You sure you want to delete the chosen customer?"

export const EDIT_EMPLOYER_MODAL_TITLE = "Close the form"
export const EDIT_EMPLOYER_MODAL_TEXT = "Are You sure you want to close the form?"